import React from "react"
import { useTranslation } from "react-i18next"

import { Checkbox } from "components"
import classes from "./OsfAccessOnly.module.scss"

const OsfAccessOnly = props => {
  const { form, setForm } = props

  const [t] = useTranslation()

  const handleIsViewed = (checked) => {
    setForm(prev => ({
      ...prev, addedBySystem: checked ? true : null
    }))
  }

  return (
    <div className={classes["checkbox-container"]}>
      <div className={classes["checkbox"]}>
        {t("سفارشات_پرسنل")}
      </div>

      <Checkbox
        checked={form.addedBySystem === true}
        onChange={handleIsViewed}
      />
    </div>
  )
}

export default OsfAccessOnly